import React, { createContext, useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const OffersContext = createContext();

export const OffersProvider = ({ children, initialCountryId, initialRegionId }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [selectedLocationType, setSelectedLocationType] = useState("country"); // "country" | "region" | "global"
  const [selectedLocationName, setSelectedLocationName] = useState("");
  const [filterMode, setFilterMode] = useState("countries");

  useEffect(() => {
    if (initialCountryId || searchParams.get("countryId")) {
      const countryId = initialCountryId || searchParams.get("countryId");
      setSelectedLocationId(countryId);
      setSelectedLocationType("country");
      // setSelectedLocationName("");
    } else if (initialRegionId || searchParams.get("regionId")) {
      const regionId = initialRegionId || searchParams.get("regionId");
      setSelectedLocationId(regionId);
      setSelectedLocationType("region");
      // setSelectedLocationName("");
    }
  }, [initialCountryId, initialRegionId, searchParams]);

  return (
    <OffersContext.Provider
      value={{
        selectedLocationId,
        setSelectedLocationId,
        selectedLocationType,
        setSelectedLocationType,
        selectedLocationName,
        setSelectedLocationName,
        setSearchParams,
      }}
    >
      {children}
    </OffersContext.Provider>
  );
};
